import { BehaviorSubject } from 'rxjs';

import { MenuPageKey, NodeCreationState } from '../types/menu-page-key';

export interface NodeCreationSectionDisplay {
	hideTitle: boolean;
	hideBackButton: boolean;
	hideWorkspaceSelector: boolean;
	hideExecuteButton: boolean;
	hideSettingsButton: boolean;
	showBackButton: boolean;
}

export const BASE_CREATION_SECTION_DISPLAY: NodeCreationSectionDisplay = {
	hideTitle: false,
	hideWorkspaceSelector: false,
	hideExecuteButton: false,
	hideBackButton: false,
	hideSettingsButton: false,
	showBackButton: false,
};

export interface FrontendNodeCreatioState<KEY extends MenuPageKey | null>
	extends NodeCreationState<KEY>, NodeCreationSectionDisplay {}

const DEFAULT_STORE: FrontendNodeCreatioState<MenuPageKey | null> = {
	key: null,
	validForm: false,
	data: null,
	workspacesIds: null,
	fromFirstAction: true,
	fromShare: false,
	...BASE_CREATION_SECTION_DISPLAY,
};

export class NodeCreationStore<KEY extends MenuPageKey | null> {
	private readonly state$$ = new BehaviorSubject(DEFAULT_STORE as FrontendNodeCreatioState<KEY>);

	public readonly state$ = this.state$$.asObservable();

	constructor(state: NodeCreationState<KEY>) {
		this.state$$.next({
			...this.state$$.value,
			...state,
		} as FrontendNodeCreatioState<KEY>);
	}

	public setState(state: Partial<FrontendNodeCreatioState<KEY>>) {
		this.state$$.next({ ...this.state$$.value, ...state } as FrontendNodeCreatioState<KEY>);
	}

	public resetState() {
		this.state$$.next(DEFAULT_STORE as FrontendNodeCreatioState<KEY>);
	}
}
